import { Fragment, ReactNode } from "react";

import { Box, Text } from "@vinomofo/components";

interface BlockquoteProps {
  authorName?: string;
  authorTitle?: string;
  quoteText: ReactNode;
}

const QuoteDivider = () => {
  return (
    <Box display="flex" flexDirection="row" alignItems="center" mb={[3, 4]}>
      <Box flexGrow="1" height="4px" backgroundColor="brand" />
      <Box
        as="svg"
        width={[50, 80]}
        mx={[2, 3]}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 72"
      >
        <path
          fill="#77B204"
          fillRule="nonzero"
          d="M25 72C13 72 0 62 0 41 0 15 13 0 38 0l9 1v13l-9-1c-7 0-12 3-16 7-3 3-6 8-6 13 2-3 6-4 11-4 12 0 20 9 20 22 0 12-9 21-22 21zm53 0c-12 0-25-10-25-31C53 15 66 0 91 0l9 1v13l-9-1c-7 0-12 3-16 7-4 3-6 8-6 13 2-3 6-4 11-4 12 0 20 9 20 22 0 12-9 21-22 21z"
        />
      </Box>
      <Box flexGrow="1" height="4px" backgroundColor="brand" />
    </Box>
  );
};

export const Blockquote = ({
  authorName,
  authorTitle,
  quoteText,
}: BlockquoteProps): JSX.Element => {
  return (
    <Box
      as="figure"
      paddingBottom={[4, 5]}
      borderBottom="1px solid"
      borderColor="primary"
      textAlign="center"
    >
      <QuoteDivider />
      <Box as="blockquote" px={4}>
        {quoteText}
      </Box>
      {authorName && (
        <Box as="figcaption" mt={3}>
          <Text as="span" color="primary" fontWeight={500} variant="sm">
            {authorName}
          </Text>

          {authorTitle && (
            <Fragment>
              <Box display="inline" verticalAlign="sub" px="10px">
                <Text
                  as="span"
                  color="brand"
                  fontWeight={500}
                  variant="lg"
                  lineHeight="none"
                >
                  ·
                </Text>
              </Box>
              <Text as="cite" variant="sm" fontStyle="normal">
                {authorTitle}
              </Text>
            </Fragment>
          )}
        </Box>
      )}
    </Box>
  );
};
